// City/region -> [latitude, longitude] for project markers on the Impact Map.
// Exhaustive coverage of every unique projects.json `location` string.
// Country fallback is used only if a location ever appears that isn't in the table.

const cityCoords = {
  // Baseline cities (from spec, kept even if not currently used in data)
  'Tampa, FL, USA': [27.9506, -82.4572],
  'Miami, FL, USA': [25.7617, -80.1918],
  'Medellín, Colombia': [6.2442, -75.5812],
  'Bogotá, Colombia': [4.7110, -74.0721],
  'Kathmandu Valley, Nepal': [27.7172, 85.3240],
  'Kathmandu, Nepal': [27.7172, 85.3240],
  'Nairobi, Kenya': [-1.2921, 36.8219],
  'Lagos, Nigeria': [6.5244, 3.3792],
  'Mumbai, India': [19.0760, 72.8777],
  'Delhi, India': [28.6139, 77.2090],
  'Manila, Philippines': [14.5995, 120.9842],
  'São Paulo, Brazil': [-23.5505, -46.6333],
  'Lima, Peru': [-12.0464, -77.0428],
  'Mexico City, Mexico': [19.4326, -99.1332],
  'Dakar, Senegal': [14.7167, -17.4677],
  'Cairo, Egypt': [30.0444, 31.2357],
  'Jakarta, Indonesia': [-6.2088, 106.8456],
  'Bangkok, Thailand': [13.7563, 100.5018],
  'Istanbul, Turkey': [41.0082, 28.9784],
  'Buenos Aires, Argentina': [-34.6037, -58.3816],

  // Every location string used in current projects.json (24 unique values)
  'Amman, Jordan': [31.9539, 35.9106],
  'Berlin, Germany': [52.5200, 13.4050],
  'Bihar, India': [25.0961, 85.3131],
  'Cusco Region, Peru': [-13.5319, -71.9675],
  'Dhaka, Bangladesh': [23.8103, 90.4125],
  'Eastern Caribbean': [13.0000, -61.2000],
  'Eastern Nepal': [27.0000, 87.0000],
  'Florida, USA': [27.6648, -81.5158],
  'Gaziantep, Turkey': [37.0662, 37.3833],
  'Gulu, Uganda': [2.7747, 32.2989],
  'Hamburg, Germany': [53.5511, 9.9937],
  'Kakamega, Kenya': [0.2842, 34.7521],
  'Kigali, Rwanda': [-1.9536, 30.0606],
  'Kisumu, Kenya': [-0.0917, 34.7679],
  'Mara Region, Tanzania': [-1.7755, 34.1532],
  'Maranhão, Brazil': [-5.0000, -45.0000],
  'North Sulawesi, Indonesia': [1.4748, 124.8421],
  'Raja Ampat, Indonesia': [-0.5897, 130.1010],
  'Rajasthan, India': [27.0238, 74.2179],
  'Sylhet, Bangladesh': [24.8949, 91.8687],
  'Visayas, Philippines': [11.0050, 123.5000],
};

// Country centroids — only consulted if a location string doesn't match the table above.
const countryCoords = {
  'USA': [39.8283, -98.5795],
  'Colombia': [4.5709, -74.2973],
  'Nepal': [28.3949, 84.1240],
  'Kenya': [-0.0236, 37.9062],
  'Nigeria': [9.0820, 8.6753],
  'India': [20.5937, 78.9629],
  'Philippines': [12.8797, 121.7740],
  'Brazil': [-14.2350, -51.9253],
  'Peru': [-9.1900, -75.0152],
  'Mexico': [23.6345, -102.5528],
  'Senegal': [14.4974, -14.4524],
  'Egypt': [26.8206, 30.8025],
  'Indonesia': [-0.7893, 113.9213],
  'Thailand': [15.8700, 100.9925],
  'Turkey': [38.9637, 35.2433],
  'Argentina': [-38.4161, -63.6167],
  'Jordan': [30.5852, 36.2384],
  'Germany': [51.1657, 10.4515],
  'Tanzania': [-6.3690, 34.8888],
  'Rwanda': [-1.9403, 29.8739],
  'Uganda': [1.3733, 32.2903],
  'Bangladesh': [23.6850, 90.3563],
  'Haiti': [18.9712, -72.2852],
  'Caribbean': [13.0000, -61.2000],
};

export function getCoordsForLocation(location) {
  if (!location || typeof location !== 'string') return null;
  if (cityCoords[location]) return cityCoords[location];
  for (const [country, coords] of Object.entries(countryCoords)) {
    if (location.includes(country)) return coords;
  }
  return null;
}

export default cityCoords;
